/**
 * Os blocos da Home clássica, disponíveis como WIDGETS (07/08/2026).
 *
 * ── Por que existem
 *
 * Decisão do Matheus: a Home passa a ser somente o que ele montar. Mas o
 * catálogo tinha 19 widgets e nenhum deles era o que a Home mostra hoje — os
 * KPIs do dia, a agenda, as atividades e as aprovações eram imports fixos da
 * `HomePage`. Sem estes quatro, ele montaria a home e não teria como incluir o
 * que a equipe já usa: a home nova nasceria mais pobre que a atual.
 *
 * ── São EMBRULHOS, não cópias
 *
 * Cada um renderiza o MESMO componente que a Home já usa. Reescrever "uma
 * versão widget" de cada bloco criaria dois lugares para consertar o mesmo
 * defeito — e o `KpisRealsWidget`, por exemplo, acabou de ganhar o escopo por
 * módulo (BUGS #84). Um motor só, dois pontos de uso.
 *
 * Por isso eles também não recebem `WidgetShell`: os blocos já trazem o próprio
 * cabeçalho e o próprio estado vazio, desenhados para a Home. Embrulhar de novo
 * daria dois títulos para o mesmo conteúdo, que é exatamente o problema que a
 * casca de Configurações já teve.
 */
import { AgendaHojeWidget } from '@/pages/home/widgets/AgendaHojeWidget';
import { AtividadesHojeWidget } from '@/pages/home/widgets/AtividadesHojeWidget';
import { KpisRealsWidget } from '@/pages/home/widgets/KpisRealsWidget';
import { PendingApprovalsWidget } from '@/components/PendingApprovalsWidget';

/**
 * O `perfilUsuario` chega por contrato do renderer, mas estes quatro blocos não
 * o usam: quem decide o que cada um mostra é o SERVIDOR (os KPIs por módulo, a
 * agenda pelo dono da tarefa, as aprovações por quem aprova). Filtrar de novo
 * aqui seria uma segunda régua de permissão — e a que vale é sempre a de lá.
 */
export function HomeKpisWidget() {
  return <KpisRealsWidget />;
}

export function HomeAgendaWidget() {
  return <AgendaHojeWidget />;
}

export function HomeAtividadesWidget() {
  return <AtividadesHojeWidget />;
}

export function HomeAprovacoesWidget() {
  return <PendingApprovalsWidget />;
}
